import { render, staticRenderFns } from "./router_view.vue?vue&type=template&id=11c9de98&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideYReverseTransition})
